import { render, staticRenderFns } from "./find-pwd.vue?vue&type=template&id=c025a462&scoped=true&"
import script from "./find-pwd.vue?vue&type=script&lang=js&"
export * from "./find-pwd.vue?vue&type=script&lang=js&"
import style0 from "./find-pwd.vue?vue&type=style&index=0&id=c025a462&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c025a462",
  null
  
)

export default component.exports